import * as React from "react";

const CENUpRightFromSquare: React.FC = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.25 2C9.94766 2 9.67344 2.18281 9.55625 2.46406C9.43906 2.74531 9.50469 3.06641 9.71797 3.28203L10.6883 4.25L6.72031 8.22031C6.42734 8.51328 6.42734 8.98906 6.72031 9.28203C7.01328 9.575 7.48906 9.575 7.78203 9.28203L11.75 5.31172L12.7203 6.28203C12.9359 6.49766 13.257 6.56094 13.5383 6.44375C13.8195 6.32656 14.0023 6.05469 14.0023 5.75V2.75C14.0023 2.33516 13.6672 2 13.2523 2H10.25ZM3.875 2.75C2.83906 2.75 2 3.58906 2 4.625V12.125C2 13.1609 2.83906 14 3.875 14H11.375C12.4109 14 13.25 13.1609 13.25 12.125V9.5C13.25 9.08516 12.9148 8.75 12.5 8.75C12.0852 8.75 11.75 9.08516 11.75 9.5V12.125C11.75 12.3313 11.5813 12.5 11.375 12.5H3.875C3.66875 12.5 3.5 12.3313 3.5 12.125V4.625C3.5 4.41875 3.66875 4.25 3.875 4.25H6.5C6.91484 4.25 7.25 3.91484 7.25 3.5C7.25 3.08516 6.91484 2.75 6.5 2.75H3.875Z"
                fill="#0F96D9"
            />
        </svg>
    );
};

export default React.memo(CENUpRightFromSquare);
